import { application } from "./application"

import SearchController from "./search_controller"
import PracticeLogController from "./practice_log_controller"
import TagToggleController from "./tag_toggle_controller"
import CollapsibleController from "./collapsible_controller"
import DismissableController from "./dismissable_controller"
import TabsController from "./tabs_controller"
import TagFilterController from "./tag_filter_controller"
import BottomSheetController from "./bottom_sheet_controller"
import StudentFormController from "./student_form_controller"
import CheckboxToggleController from "./checkbox_toggle_controller"

application.register("search", SearchController)
application.register("practice-log", PracticeLogController)
application.register("tag-toggle", TagToggleController)
application.register("collapsible", CollapsibleController)
application.register("dismissable", DismissableController)
application.register("tabs", TabsController)
application.register("tag-filter", TagFilterController)
application.register("bottom-sheet", BottomSheetController)
application.register("student-form", StudentFormController)
application.register("checkbox-toggle", CheckboxToggleController)
